
//TO-DO: Passar estes métodos para a model-sagres
export class FiltrosOscip {
    cnpj: string
    nomeEntidade: string
    tipoDocumento: string
    cidade: string
    uf: string
    ativo: string

    constructor() {
        this.limpar();
    }

    limpar(): void {
        this.cnpj = ''
        this.nomeEntidade = ''
        this.tipoDocumento = ''
        this.cidade = ''
        this.uf = ''
        this.ativo = ''
    }

    toFormData(): FormData {
        const data = new FormData()
        if (this.cnpj)
            data.append("cnpj", this.cnpj)
        if (this.nomeEntidade)
            data.append("nomeEntidade", this.nomeEntidade)
        if (this.tipoDocumento)
            data.append("tipoDocumento", this.tipoDocumento)
        if (this.cidade)
            data.append("cidade", this.cidade)
        if (this.uf)
            data.append("uf", this.uf)
        if (this.ativo)
            data.append("ativo", this.ativo)
        return data
    }

    toQueryString(): string {
        let retorno = ''
        if (this.cnpj)
            retorno += '&Cnpj=' + this.cnpj
        if (this.nomeEntidade)
            retorno += '&NomeEntidade=' + this.nomeEntidade
        if (this.tipoDocumento)
            retorno += '&TipoDocumento=' + this.tipoDocumento
        if (this.cidade)
            retorno += '&Cidade=' + this.cidade
        if (this.uf)
            retorno += '&Uf=' + this.uf
        if (this.ativo)
            retorno += '&Ativo=' + this.ativo
        return retorno
    }
}